import _ from 'lodash';

function encode(x) {
	return x == null ? '' : encodeURIComponent(x);
}

export function jsonToParamString(params) {
	return _.map(params, (v, k) => {
			let key = encode(k);
			let value;
			if (Array.isArray(v)) {
				value = encode(v.map(x => encode(x)).join())
			} else if (typeof v === 'function') {
				value = encode(v());
			} else {
				value = encode(v);
			}
			return key + "=" + value;
		},
	).join('&');
}
